const appSettings = {
    authority: import.meta.env.VITE_AUTHORITY_URL,
    client_id: import.meta.env.VITE_APP_AUTH_CLIENT_ID,
    client_secret: import.meta.env.VITE_APP_AUTH_CLIENT_SECRET,
    redirect_uri: import.meta.env.VITE_APP_AUTH_REDIRECT_URI,
    silent_redirect_uri: import.meta.env.VITE_APP_AUTH_REDIRECT_URI,
    post_logout_redirect_uri: import.meta.env.VITE_APP_AUTH_LOGOUT_REDIRECT_URI,
    response_type: 'code',
    scope: 'inspection'
};

export const appConfig = {
    settings: appSettings,
    flow: 'appFlow'
};